module.exports = __webpack_public_path__ + "img/imageEmpty.76cfe25b.svg";